import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import * as React from "react";
import { WishCounterWidget } from "./wtg-widgets";
import { ScriptLoader } from "../components/script-loader";
import { siteMetadata } from "../../gatsby-config.js";
export var StartWishToGo = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(StartWishToGo, _React$Component);

  function StartWishToGo() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = StartWishToGo.prototype;

  _proto.initScript = function initScript() {
    window['wtgInit']();
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (window['wtgDismount']) window['wtgDismount']();
  };

  _proto.render = function render() {
    var _this = this;

    var _onLoad = this.props.onLoad;
    var scriptUrl = siteMetadata.scriptUrl + '/wish-to-go.main.js';
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ScriptLoader, {
      initScript: function initScript() {
        return _this.initScript();
      },
      onLoad: function onLoad() {
        return _onLoad && _onLoad();
      }
    }, /*#__PURE__*/React.createElement("script", {
      type: "text/javascript",
      src: scriptUrl
    })), !this.props.noCounter && /*#__PURE__*/React.createElement(WishCounterWidget, null));
  };

  return StartWishToGo;
}(React.Component);